export default "__VITE_ASSET__wRykBs9a__"